import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Box from "@mui/material/Box";
import { BASE_IMAGE_URL } from "../../config/ApiConfig";
import CustomLoading from "../CommonComp/CustomLoading/CustomLoading";

const ScrollGallery = React.memo(
  ({
    finalData,
    handleInformationImage,
    makeImageUrl,
    handleOpenModal,
    hoveredImage,
    setHoveredImage,
  }) => {
    return (
      <div className="custom-gallery">
        {finalData?.length
          ? finalData?.map((item, index) => {
              return (
                <div
                  key={index.toString()}
                  className={`${
                    item?._source.alignment == "V"
                      ? "imageItem-Vertical"
                      : item?._source.alignment == "S"
                      ? "imageItem-square"
                      : "imageItem-Horizontal"
                  } pie-menu-main-div`}
                  onMouseOver={() => {
                    setHoveredImage(item?._source?.imagename);
                  }}
                >
                  <img
                    onClick={() => handleInformationImage(item)}
                    className="w-100"
                    src={makeImageUrl(item)}
                    alt={item?._source?.imagename}
                    loading="lazy"
                  />
                </div>
              );
            })
          : null}
      </div>
    );
  }
);

const ImagesSearchGallery
 = ({
  finalData,
  fetchData,
  hasMore,
  isLoadingImages,
  handleOpenModal,
  openModal,
  sliderNumber,
  prevSlide,
  nextSlide,
  handleCloseModal,
}) => {
  const [hoveredImage, setHoveredImage] = useState(null);
  const makeImageUrl = (imageData) => {
    if (imageData) {
      const dataOfImage = imageData?._source?.url?.split("/");
      return `${BASE_IMAGE_URL}${dataOfImage[0]}/${dataOfImage[1]}-${dataOfImage[2]}.jpg`;
    }
  };

  const handleInformationImage = (item) => {};
  useEffect(() => {
    if (openModal) {
      try {
        setTimeout(() => {
          let element = document?.getElementById("modalImageDiv");
          if (element) {
            element.focus();
          }
        }, 1000);
      } catch (e) {}
    }
  }, [openModal]);
  return (
    <>
      <Box sx={{ marginTop: "20px" }}>
        {finalData?.length > 0 ? (
          <InfiniteScroll
            dataLength={finalData?.length * 10}
            next={fetchData}
            hasMore={hasMore}
            loader={
              <h4
                style={{
                  textAlign: "center",
                  paddingTop: "10px",
                  color: "black",
                }}
              >
                Loading...
              </h4>
            }
            endMessage={
              <h4
                style={{
                  textAlign: "center",
                  paddingTop: "30px",
                  color: "black",
                }}
              >
                {"You got all data"}
              </h4>
            }
            scrollThreshold={0.65}
          >
            <ScrollGallery
              finalData={finalData}
              handleInformationImage={handleInformationImage}
              makeImageUrl={makeImageUrl}
              handleOpenModal={handleOpenModal}
              hoveredImage={hoveredImage}
              setHoveredImage={setHoveredImage}
            />
          </InfiniteScroll>
        ) : (
          <CustomLoading
            loading={isLoadingImages}
            loadingStyle={{ marginTop: 30 }}
            loadingFinishText={"No images found"}
          />
        )}
      </Box>
      {openModal && (
        <>
          <div
            className="slider-wrap-div"
            tabIndex={0}
            onClick={(e) => {
              handleCloseModal();
            }}
            id="modalImageDiv"
            onKeyDown={(e) => {
              if (e.key == "ArrowLeft") {
                prevSlide();
              } else if (e.key == "ArrowRight") {
                nextSlide();
              } else if (e.key == "Escape") {
                handleCloseModal();
              }
            }}
          >
            slde,{sliderNumber}
            <ModalCross
              onClick={handleCloseModal}
              className="close-modal-wrap"
            />
            <LeftArrow
              onClick={(e) => {
                e.stopPropagation();
                prevSlide();
              }}
              className="prev-modal-wrap"
            />
            <RightArrow
              onClick={(e) => {
                e.stopPropagation();
                nextSlide();
              }}
              className="next-modal-wrap"
            />
            <div className="full-screen-image">
              <div
                className="show-image-menu-w-hover"
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <img
                  src={makeImageUrl(finalData && finalData[sliderNumber])}
                  alt="image"
                  style={{
                    maxHeight:
                      finalData[sliderNumber]?._source.alignment === "V" ||
                      finalData[sliderNumber]?._source.alignment === "S"
                        ? "80vh"
                        : "",
                  }}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ImagesSearchGallery;
